import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LexgosignService } from '@services/lexgosign.service';
import { ToastService } from '@flows/shared/toast/toast-service';

@Component({
  selector: 'app-lexgosign-folder-picker',
  templateUrl: './lexgosign-folder-picker.component.html',
  styleUrls: ['./lexgosign-folder-picker.component.scss'],
  standalone: false
})
export class LexgosignFolderPickerComponent implements OnInit {
  /** Carpeta inicial / preseleccionada */
  @Input() initialPath = 'Contratos';

  loading = false;
  currentPath = 'Contratos';
  parentPath: string | null = null;
  folders: { name: string; path: string }[] = [];
  selectedPath = 'Contratos';
  newFolderName = '';

  constructor(
    public activeModal: NgbActiveModal,
    private lexgosignService: LexgosignService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    const start = (this.initialPath || 'Contratos').trim() || 'Contratos';
    this.load(start);
  }

  load(path: string) {
    this.loading = true;
    this.lexgosignService.listFiles(path).subscribe({
      next: (res) => {
        this.currentPath = res.path || 'Contratos';
        this.parentPath = res.parentPath;
        this.folders = res.folders || [];
        this.selectedPath = this.currentPath;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.toastService.show(err?.message || 'No se pudo cargar carpetas', {
          classname: 'bg-danger text-light',
          delay: 5000
        });
      }
    });
  }

  selectFolder(path: string) {
    this.selectedPath = path;
  }

  openFolder(path: string) {
    this.load(path);
  }

  goUp() {
    if (this.parentPath) this.load(this.parentPath);
  }

  createFolder() {
    const name = (this.newFolderName || '').trim();
    if (!name) return;
    this.lexgosignService.createFolder(this.currentPath, name).subscribe({
      next: (resp) => {
        if (resp?.success === false) {
          this.toastService.show(resp.message || 'No se pudo crear', {
            classname: 'bg-danger text-light',
            delay: 4000
          });
          return;
        }
        this.newFolderName = '';
        const createdPath = resp?.result?.path;
        this.load(this.currentPath);
        if (createdPath) this.selectedPath = createdPath;
      },
      error: (err) => {
        this.toastService.show(err?.error?.message || err?.message || 'Error', {
          classname: 'bg-danger text-light',
          delay: 4000
        });
      }
    });
  }

  confirm() {
    this.activeModal.close(this.selectedPath || 'Contratos');
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
